import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

// Minimal shared tag component.
@Component({
  selector: 'az-tag',
  imports: [CommonModule],
  templateUrl: './az-tag.component.html',
  styleUrls: ['./az-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AzTagComponent {
  // status used to build modifier class e.g. tag--pending
  @Input() status: string = '';
  // Optional fixed width (fallback to 74px like original). Allow override.
  @Input() width: string | number | null = null;
  // Loading state; when true ignore status modifiers except loading
  @Input() loading: boolean = false;
  // Customizable loading text (content projection can still override if provided)
  @Input() loadingText: string = 'Loading...';

  get styleWidth(): string | null {
    if (this.width === null || this.width === undefined || this.width === '') return null;
    return typeof this.width === 'number' ? `${this.width}px` : this.width;
  }

  get hostClasses(): Record<string, boolean> {
    const slug = this.slugify(this.status || '');
    return {
      'tag-wrapper': true,
      [`tag--${slug}`]: !!slug && !this.loading,
      'tag--loading': this.loading,
    };
  }

  // Slugify a status value so multi-word statuses (e.g. "Not in the scope")
  // produce a single valid CSS class key instead of being split by NgClass
  // when the key itself contains whitespace.
  private slugify(value: string): string {
    return value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}
